
import Image1 from '../assets/CardImage1.jpeg'
import Image2 from '../assets/CardImage2.jpeg'


import Image5 from '../assets/CardImage5.jpeg'
import Image6 from '../assets/CardImage6.jpeg'
import Image7 from '../assets/CardImage7.jpeg'
import Image8 from '../assets/CardImage8.jpeg'
import Image9 from '../assets/CardImage9.jpeg'
import Image10 from '../assets/CardImage10.jpeg'
import Image11 from '../assets/CardImage11.jpeg'
import Image12 from '../assets/CardImage12.jpeg'
import Image13 from '../assets/CardImage13.jpeg'
import Image14 from '../assets/CardImage14.jpeg'
import Image15 from '../assets/CardImage15.jpeg'
import Image16 from '../assets/CardImage16.jpeg'
import Image17 from '../assets/CardImage17.jpeg'
import Image18 from '../assets/CardImage18.jpeg'
import Image19 from "../assets/cardImage19.jpeg"
import Image20 from "../assets/cardImage20.jpeg"
import Image21 from "../assets/cardImage21.jpeg"
import Image22 from "../assets/cardImage22.jpeg"
import Image23 from "../assets/CardImage23.jpeg"
import Image24 from "../assets/CardImage24.jpeg"
import Image25 from "../assets/CardImage25.jpeg"
import Image26 from "../assets/CardImage26.jpeg"

const Data = [
    {
        title : 'MUN Conference 2024',
        Description : "",
        image : Image19
    },
    {
        title : 'MUN Conference 2024',
        Description : "",
        image : Image20
    },
    {
        title : 'MUN Conference 2024',
        Description : "",
        image : Image21
    },
    {
        title : 'MUN Conference 2024',
        Description : "",
        image : Image22
    },
    {
        title : 'Plantation Work',
        Description : "Plantation agriculture has a long history, dating back to the colonial period when European powers established colonies and exploited the natural resources of their colonies for economic gain. ",
        image : Image1
    },
    {
        title : 'International Youth Day',
        Description : "International Youth Day is a United Nations observance that takes place annually on August 12th. The day was first designated in 1999 by the UN General Assembly to raise awareness of the challenges and opportunities faced by young people worldwide.",
        image : Image2
    },
    
    {
        title : 'Open Government Partnership',
        Description : " The Open Government Partnership (OGP) is a global initiative launched in 2011 that aims to promote transparency, accountability, citizen participation, and technology and innovation in government.  ",
        image : Image5
    },
    {
        title : 'National Youth Facilitated programme',
        Description : "A National Youth Facilitated Program is a program that is designed and facilitated by young people to address issues that affect them and their communities. ",
        image : Image6
    },
    {
        title : 'Youth parliament practice',
        Description : "Youth parliament is a practice in which young people come together to discuss and debate issues that affect them and their communities, and to develop proposals and recommendations for policy makers.",
        image : Image7
    },
    {
        title : 'Women and Health Training Workshop Partnerships  Denmark 🇩🇰 Doctors ',
        Description : "Yes we are intending improving and changing our community by using sustainable development goal No: 3 and their Policy and its true  finally we gave special oppourtunity to the Denish Doctors and their team for women health and the maturnity.Thank you Social welfare council team, Support Umbrella Team and Nepalese Nurses.",
        image : Image8
    },
    {
        title : 'Women and Health Training Workshop Partnerships  Denmark 🇩🇰 Doctors ',
        Description : "Yes we are intending improving and changing our community by using sustainable development goal No: 3 and their Policy and its true  finally we gave special oppourtunity to the Denish Doctors and their team for women health and the maturnity.Thank you Social welfare council team, Support Umbrella Team and Nepalese Nurses.",
        image : Image9
    },
    {
        title : 'Women and Health Training Workshop Partnerships  Denmark 🇩🇰 Doctors ',
        Description : "Yes we are intending improving and changing our community by using sustainable development goal No: 3 and their Policy and its true  finally we gave special oppourtunity to the Denish Doctors and their team for women health and the maturnity.Thank you Social welfare council team, Support Umbrella Team and Nepalese Nurses.",
        image : Image10
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image11
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image12
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image13
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image14
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image15
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image16
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image17
    },
    {
        title : 'International Youth Day 2023',
        Description : "International Youth Day is an annual observance dedicated to celebrating the contributions, potential, and achievements of young people around the world. Recognized on August 12th, it provides a platform to raise awareness about the challenges and issues faced by youth, while also promoting their engagement in various social, political, and economic spheres.",
        image : Image18
    },
      {
        title : '13th International Summer School on Digital Government',
        Description : "Participated in an international summer school focused on Government 3.0, ICT-enabled governance, Open Data, AI, and emerging technologies, gaining insights through expert sessions, workshops, and interactive learning.",
        image : Image23
    },
    {
        title : '13th International Summer School on Digital Government',
        Description : "Explored policy modelling, information management, data-driven decision making, transparency, privacy, and disruptive ICTs, while engaging with internationally recognized researchers and professionals in digital governance.",
        image : Image24
    },
    {
        title : '13th International Summer School on Digital Government',
        Description : "Engaged with international researchers, professionals, and experts in digital governance, exchanging perspectives and building connections around ICT, emerging technologies, and the future of Government 3.0.",
        image : Image25
    },
    {
        title : '13th International Summer School on Digital Government',
        Description : "Connected with international participants, researchers, and professionals, sharing experiences and perspectives while exploring the collaborative and cultural side of the OpenGov2026 summer school in Samos, Greece.",
        image : Image26
    },
    

]

export default Data;



